import React from 'react';
import SideMenuBar from '../../components/account/SideMenuBar';
import RightBar from '../../components/account/RightBar';
import ExChnageContent from '../../components/account/ExChangeContent';
import { isMobilePage } from '../../common/cores';

const ExChange = () => {
    return (
        <div data-v-623d66c4="" className="contents row" style={{flexDirection: "row"}}>
            <div data-v-623d66c4="" className="content column right-content">
                <div data-v-623d66c4="" className="column">
                    <div data-v-394b74b4="" data-v-623d66c4="" className="account row" style={{ flexDirection: "row"}}>
                        {!isMobilePage() && <SideMenuBar />}
                        <ExChnageContent />
                    </div>
                </div>
            </div>
            {!isMobilePage() && <RightBar />}
        </div>
    );
};

export default ExChange;


// WEBPACK FOOTER //
// ./src/containers/Account/ExChange.js